import Siema from 'siema';
import tippy from 'tippy.js'
import 'lazysizes';
import Plyr from 'plyr';
import $ from "jquery";

window.tippy = tippy;

if(window.innerWidth < 992) {
    let drawer = require('./drawer.js');

    // if(document.querySelector('.features__list')) {
    //     new Siema({
    //         selector: '.features__list',
    //         perPage: 1,
    //     });
    // }

    if(document.querySelector('.target__list')) {
        document.querySelector('.target .container').innerHTML +=
            '<button type="button" class="siema__prev"></button>' +
            '<button type="button" class="siema__next"></button>';

        const targetSlider = new Siema({
            selector: '.target__list',
            perPage: 1,
            onInit: () => {
                document.querySelector('.target .siema__prev').addEventListener('click', () => targetSlider.prev());
                document.querySelector('.target .siema__next').addEventListener('click', () => targetSlider.next());
            },
        });
    }

    if(document.querySelector('.references__list')) {
        document.querySelector('.references .container').innerHTML +=
            '<button type="button" class="siema__prev"></button>' +
            '<button type="button" class="siema__next"></button>';

        const referencesSlider = new Siema({
            selector: '.references__list',
            perPage: 1,
            onInit: () => {
                document.querySelector('.references .siema__prev').addEventListener('click', () => referencesSlider.prev());
                document.querySelector('.references .siema__next').addEventListener('click', () => referencesSlider.next());
            },
        });
    }
}

if(document.querySelector('.header')) {
    let scrollPosition = 0;
    let scrollDirection = 0;
    let ticking = false;
    const header = document.querySelector('.header');
    const headerHeight = parseInt(window.getComputedStyle(header).height, 10);

    if (window.scrollY === 0) {
        header.classList.add('header--transparent');
    }

    window.addEventListener('scroll', function (e) {
        scrollDirection = window.scrollY - scrollPosition;
        scrollPosition = window.scrollY;

        if (!ticking) {

            if(scrollPosition < headerHeight) {
                header.classList.add('header--transparent');
            }
            else {
                header.classList.remove('header--transparent');
            }

            window.requestAnimationFrame(function () {
                headerScroll(scrollDirection);
                ticking = false;
            });

            ticking = true;

        }
    });

    function headerScroll(scrollDirection) {
        let position = parseInt(window.getComputedStyle(header).top, 10);

        if((position - scrollDirection < -headerHeight || (window.innerHeight + window.scrollY) >= document.body.offsetHeight) && window.scrollY >= headerHeight) {
            header.style.top = '-' + headerHeight + 'px';
        }
        else if(position - scrollDirection > 0 || window.pageYOffset <= 0 || window.scrollY == 0) {
            header.style.top = '0px';
        }
        else {
            header.style.top = position - scrollDirection + 'px';
        }
    }
}

if (document.querySelectorAll('.video__player').length > 0) {
    const players = Array.from(document.querySelectorAll('.video__player')).map(p => new Plyr(p, {
        settings: ['quality', 'speed'],
        youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, cc_load_policy: 1 },
    }));
}

document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(function(item){
    item.addEventListener('click', function (e) {
        e.preventDefault();
        let path = this.getAttribute('href').replace(/^\/+/, '').replace(/^#+/, '');

        if(document.querySelector('*[id="'+ path +'"]')) {
            if(window.innerWidth < 992) {
                document.querySelector('.nav__button').click();
            }

            document.querySelector('*[id="'+ path +'"]').scrollIntoView({behavior: 'smooth'});
        }
        else {
            window.location = this.href;
        }
    });
});

// const priceLists = document.querySelectorAll('.price-list__item');
//
// priceLists.forEach(function (priceList) {
//     const price = priceList.querySelector('.price-list__calc');
//     let step;
//     let value;
//     let min;
//     let max;
//
//     document.querySelectorAll('.configurable').forEach(function (configurable) {
//         step = configurable.dataset.step;
//         value = configurable.querySelector('.configurable_value');
//         min = configurable.dataset.min;
//         max = configurable.dataset.max;
//     });
//
//     document.querySelectorAll('.configurable .configurable__button').forEach(function (button) {
//         button.addEventListener('click', function () {
//             if (this.classList.contains('configurable__button--remove')) {
//                 let newValue = parseInt(value.innerText) - step;
//
//                 if (newValue >= min) {
//                     value.innerText = newValue;
//                     price.innerText = parseInt(price.innerText) - 10;
//                 }
//             }
//             else if (this.classList.contains('configurable__button--add')) {
//                 let newValue = parseInt(value.innerText) + step;
//
//                 if (max > 0) {
//                     if (newValue <= max) {
//                         value.innerText = newValue;
//                         price.innerText = parseInt(price.innerText) + 10;
//                     }
//                 } else {
//                     value.innerText = newValue;
//                     price.innerText = parseInt(price.innerText) + 10;
//                 }
//             }
//         });
//     });
// });

$(document).ready(function () {
    $('.configurable .configurable__button').click(function () {
        var step = $(this).closest('.configurable').data('step');
        var value = $(this).closest('.configurable').find('.configurable_value');
        var min = $(this).closest('.configurable').data('min');
        var price = $(this).closest('.price-list__content').find('.price-list__calc');
        var max = $(this).closest('.configurable').data('max');

        // console.log(step);
        // console.log(value.text());

        if ($(this).hasClass('configurable__button--remove')) {
            var newValue = parseInt(value.text()) - step;

            if (newValue >= min) {
                value.text(newValue);
                price.text(parseInt(price.text()) - 10);
            }
        } else if ($(this).hasClass('configurable__button--add')) {
            var newValue = parseInt(value.text()) + step;

            if (max > 0) {
                if (newValue <= max) {
                    value.text(newValue);
                    price.text(parseInt(price.text()) + 10);
                }
            } else {
                value.text(newValue);
                price.text(parseInt(price.text()) + 10);
            }
        }
    });

    $('.prices__configurator input[name="satshop-price"]').change(function() {
        const name = $(this).parent().data('satshop-name');
        const price = $(this).parent().data('satshop-price');
        const costs = $(this).parent().data('satshop-costs');
        const contract = $(this).parent().data('satshop-contract');
        const explanation = $(this).parent().data('satshop-explanation');
        const design = $('.prices__configurator input[name="satshop-design-price"]');

        $('.prices__summary-product-name').text(name);
        $('.prices__summary-product-price span').text(price);
        $('.prices__summary-one-off-price span').text(costs);
        $('.prices__summary-contract-type span').text(contract);
        $('.prices__selector-explanation').html(explanation);

        if(design[0].checked) {
            $('.prices__summary-one-off-price span').text(parseInt(costs) + parseInt(design.parent().data('satshop-costs')));
        }
    });

    $('.prices__configurator input[name="satshop-design-price"]').change(function() {
        const costs = $(this).parent().data('satshop-costs');
        const current = $('.prices__summary-one-off-price span').text();

        if($(this)[0].checked) {
            $('.prices__summary-one-off-price span').text(parseInt(current) + parseInt(costs));
        }
        else {
            $('.prices__summary-one-off-price span').text(parseInt(current) - parseInt(costs));
        }
    });
});

tippy(document.querySelectorAll('.tooltip'), {
    placement: 'right',
    delay: 100,
    arrow: true,
    arrowType: 'sharp',
    size: 'large',
    duration: 500,
    animation: 'shift-toward'
});